module.exports = {
  bindings: {
    group: '<',
  },
  templateUrl: 'main/components/group-info/group-info.html',
};



// WEBPACK FOOTER //
// ./main/components/group-info/group-info.js